module.exports = __webpack_public_path__ + "img/logo-feelgoodplus-tagline-english.a18fc081.png";